/*eslint-disable no-undef,no-redeclare,no-empty,no-unused-vars */
import April from '../../ALizard/April'

export default ()=>{
    April.define("log.avoid", function(args){
        if(args.opr == 'split'){
            return false;
        }else if(args.opr == 'next'){
        }else if(args.opr == 'back'){
        }else if(args.opr == 'play'){
            var scene=args.scene;
            var ch = args.scene.member[args.player];
            scene.flare("act_console", { value: "call DisplayComponent/hit.avoid" });
            args.tweener
                .call(function(_args){
                    phina.display.Sprite( // TODO 暫定
                        'img/ui/dodge.png'
                    ).setSize(50,25).addChildTo(ch)
                    .setPosition(-20,-20).setSize(75,40)
                    .tweener
                        .wait(1000)
                        .fadeOut(100)
                        .call(function(){ this.remove(); });
                }, null, [args]);
        }
    });
}
